(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bullit-immersive-menu"] && !Shopify.designMode) return;
  try {
    window.addEventListener("DOMContentLoaded", (ev) => {

        const toggleButton = document.querySelector(".bullit-immersive-menu-toggle");
        const menu = document.querySelector(".bullit-immersive-menu");

        function open() {
            toggleButton.setAttribute("aria-expanded", true);
            menu.classList.add("is-open");
        }

        function close() {
            toggleButton.setAttribute("aria-expanded", false);
            menu.classList.remove("is-open");
        }

        function toggle(ev) {
            const state = toggleButton.getAttribute("aria-expanded") === "true";

            if (!state) {
                open();
            } else {
                close();
            }
        }

        toggleButton.addEventListener("click", (ev) => { toggle(ev); });

    });
  } catch(e) { console.error(e); }
})();

})();
